import storage from 'redux-persist/lib/storage';
import { metadataTransformer } from './presistTransformers';

export const rootPersistConfig = {
  key: 'root',
  storage: storage,
  whitelist: ['metadata'],
  transforms: [metadataTransformer],
};
export const appStatePersistConfig = {
  key: 'appState',
  storage: storage,
  blacklist: [
    'failedTransactionModal',
    'failedTransactionModalMessage',
    'cvvModalFlag',
    'expiryDateModalFlag',
  ],
};
